import { lang } from '@umu/ukit-lang';
import {
    ITemplateTypeMapInfo,
    TemplateType,
    PanelType,
    IMultiCapabilityTemplatePageInfo,
    ITemplateListInfo,
} from '../interface/multiCapabilityTemplate';

const templateTypeMapInfo: ITemplateTypeMapInfo = {
    [TemplateType.MY]: {
        title: lang('我的模板'),
        emptyText: lang('暂无我的模板'),
    },
    [TemplateType.UMU]: {
        title: lang('UMU模板'),
        emptyText: lang('暂无UMU模板'),
    },
    [TemplateType.ENTERPRISE]: {
        title: lang('企业模板'),
        emptyText: lang('暂无企业模板'),
    },
};
const templateTypeTabList = [TemplateType.MY, TemplateType.ENTERPRISE, TemplateType.UMU].map((item) => {
    return {
        label: templateTypeMapInfo[item].title,
        value: item,
    };
});
const defaultListData: ITemplateListInfo = {
    list: [],
    page_info: {
        current_page: 1,
        list_total_num: 0,
        total_num: 0,
        size: 10,
        total_page_num: 1,
    },
};
const defaultPageInfo: IMultiCapabilityTemplatePageInfo = {
    isLoading: true,
    title: lang('设置多维度评价'),
    isShowBack: false,
    editorConfig: {
        isShowPreview: false,
    },
    templateType: TemplateType.ENTERPRISE,
    panelType: PanelType.LIST,
    dataSource: {
        listData: {
            [TemplateType.MY]: defaultListData,
            [TemplateType.UMU]: defaultListData,
            [TemplateType.ENTERPRISE]: defaultListData,
        },
    },
};
const onTransformNumberToChart = (num: number) => {
    return String.fromCharCode(65 + (num % 65));
};
export { onTransformNumberToChart, defaultListData, templateTypeMapInfo, templateTypeTabList, defaultPageInfo };
